import { ICommand, IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IAuthToken } from 'utility-ng-auth-token';
import { StcCustomContentsModel } from '../models/stc_custom_contents_model';

angular
  .module('data-ng-custom-text')
  .factory(
    'loadStcCustomContentsCommand',
    (
      defineCommandORM: IDefineCommand,
      log: any,
      ngStcCustomContentsModel: StcCustomContentsModel,
      authToken: IAuthToken
    ): ICommand => {
      let activePromise: any = false;
      return defineCommandORM(
        'loadStcCustomContentsCommand',
        (deferred: ng.IDeferred<IQuery[]>, attendance_id: number): void => {
          if (!activePromise) {
            activePromise = authToken
              .campusTokenRequest({
                url: '/api/v3/custom_contents'
              })
              .then((response: any) => {
                ngStcCustomContentsModel.write(response.data);
                deferred.resolve(response.data);
                activePromise = false;
              })
              .catch((err: Error) => {
                log.error('unable to load stc custom contents');
                deferred.reject(err);
                activePromise = false;
              });
            return activePromise;
          } else {
            return activePromise;
          }
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/data-ng-custom-text/src/commands/load_stc_custom_contents_command.ts